import React from 'react';
import PropTypes from 'prop-types';
import { StyledValue, StyledPlaceholder } from './styled';

const Value = ({ value, placeholderColor, placeholder, formatOptionLabel, selectedValue }) => {
  if (!selectedValue && value) {
    return null;
  }

  if (!selectedValue && !value) {
    return (
      <StyledPlaceholder color={placeholderColor} >
        {placeholder}
      </StyledPlaceholder>
    );
  }
  
  return !value && (
    <StyledValue>
      {formatOptionLabel(selectedValue)}
    </StyledValue>
  );
};

Value.propTypes = {
  value: PropTypes.string,
  placeholderColor: PropTypes.string,
  placeholder: PropTypes.string,
  selectedValue: PropTypes.any,
  formatOptionLabel: PropTypes.func.isRequired,
};

export default Value;